<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="标题/联系人/电话" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.small_project_id" clearable filterable placeholder="零星项目">
                                        <Option :value="item.small_project_id" v-for="(item,index) in projectList" :key="index">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.type_id" clearable filterable placeholder="维保类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.head_id" clearable filterable placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="维保状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建维保记录</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="maintain_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" fixed-shadow="hide" no-data-text="暂无数据记录">
                                <template #title="{ row }">
                                    <div @click="showData(row.maintain_id)" class="d-width text-primary cursor" :title="row.title">
                                        <span>{{row.title}}</span>
                                    </div>
                                </template>
                                <template #small_project_id="{ row }">
                                    <div class="d-width" :title="row.project_name">
                                        {{row.project_name ?? '-'}}
                                    </div>
                                </template>
                                <template #customer_name="{ row }">
                                    <div class="d-width">
                                        {{ row.customer_name ?? '-' }}
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <div class="d-width" :title="row.type_name">
                                        <Tag>{{row.type_name}}</Tag>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money">
                                        <strong class="text-violet">{{row.money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #work_id="{ row }">
                                    <div class="d-width">
                                        <Tag v-for="(item,idx) in row.work_list" :key="idx">{{item.real_name}}</Tag>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="orange" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 2" color="red" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-primary" @click="editData(row.maintain_id)">编辑</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-danger" @click="deleteData(row.maintain_id)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getMaintainConfig, getMaintainList, deleteMaintain} from '@/apis/dispersed'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./MaintainCreate";
import ShowModal from "./MaintainShow";
export default {
    name: "DispersedMaintain",
    components: {
        Headers, Side, AddModal, ShowModal
    },
    data () {
        return {
            typeList: [],
            userList: [],
            statusList: [],
            projectList: [],

            search: {
                name: '',
                small_project_id: '',
                type_id: '',
                head_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '维保标题',
                    key: 'title',
                    slot: 'title',
                    fixed:'left',
                    minWidth: 180,
                },
                {
                    title: '零星项目',
                    key: 'small_project_id',
                    slot: 'small_project_id',
                    minWidth: 160,
                },
                {
                    title: '维保类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 110
                },
                {
                    title: '甲方',
                    key: 'customer_name',
                    slot: 'customer_name',
                    minWidth: 160,
                },
                {
                    title: '维保金额',
                    key: 'money',
                    slot: 'money',
                    width: 120
                },
                {
                    title: '联系人',
                    key: 'contact_name',
                    width: 100
                },
                {
                    title: '联系电话',
                    key: 'contact_mobile',
                    width: 120
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 90
                },
                {
                    title: '施工人员',
                    key: 'work_id',
                    slot: 'work_id',
                    minWidth: 160
                },
                {
                    title: '开始时间',
                    key: 'start_time',
                    width: 120
                },
                {
                    title: '结束时间',
                    key: 'end_time',
                    width: 120
                },
                {
                    title: '维保状态',
                    key: 'status',
                    slot: 'status',
                    width: 100
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width: 150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    fixed:'right',
                    width : 120
                }
            ],
            is_create : false,
            is_show : false,
        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：搜索
         time: 2026/09/12
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：刷新
         time: 2026/09/12
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                small_project_id: '',
                type_id: '',
                head_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：配置
         time: 2026/09/12
         **/
        getConfig(){
            let that = this;
            getMaintainConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },
        /**
         功能：列表
         time: 2026/09/12
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getMaintainList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2026/09/12
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：创建
         time: 2026/09/12
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        editData(maintain_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(maintain_id);
            })
        },
        /**
         功能：操作返回
         time: 2026/09/12
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        showData(maintain_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(maintain_id);
            })
        },
        /**
         功能：删除
         time: 2026/09/12
         **/
        deleteData(maintain_id){
            let that = this;
            if(!maintain_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除维保记录',
                content: '此操作将删除维保记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteMaintain(maintain_id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.getList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
